// Nada status scan: operator tahu hasil tanpa melihat layar.
import { playScanBeep } from "./scan_mockup";

const PATTERNS = {
  ready: [[1180, 120]],
  done: [[880, 110], [880, 110]],
  blocked: [[420, 170], [290, 240]],
  success: [[1000, 90], [1250, 90], [1500, 170]],
};

export const TONE_LEGEND = "Bunyi: 1× tinggi = siap diperiksa · 2× ding = sudah selesai · rendah turun = belum bisa · naik 3 nada = berhasil";

export function playTone(kind) {
  if (kind === "error") return playScanBeep({ kind: "err", durationMs: 180 });
  let t = 0;
  for (const [freq, ms] of PATTERNS[kind] || PATTERNS.ready) {
    setTimeout(() => playScanBeep({ freq, durationMs: ms }), t);
    t += ms + 70;
  }
}
